export default __webpack_public_path__ + "static/media/epromissory_template.30bbfd94.png";